import styled from 'styled-components';

import { Modal } from '@pkg/components';

export const ModalLayout = styled(Modal.Layout)`
    padding: 90px 25px 50px 25px;
    gap: 16px;

    @media (min-width: ${({ theme }) => theme.breakpoints.mobile}) {
        padding: 80px 100px 80px 100px;
    }
`;

export const Heading = styled.div`
    font-weight: 700;
    font-size: 30px;
    line-height: 105%;
    text-align: center;
    letter-spacing: -0.04em;
    margin-top: 20px;

    @media (min-width: ${({ theme }) => theme.breakpoints.mobile}) {
        margin-top: 6px;

        font-size: 40px;
        line-height: 85%;
    }
`;

export const InputWrapper = styled.div`
    width: 100%;
    margin-top: 8px;

    .yat-standard-input {
        > div {
            padding: 0 20px 0 25px;
        }
    }

    .yat-standard-input__error-label {
        width: 90%;
    }

    .yat-standard-input__input-and-label {
        display: flex;
        align-items: center;
        justify-content: flex-start;
    }

    .yat-standard-input--focused {
        input {
            height: 60px;
            padding-top: 15px;
            font-size: 20px;
        }

        .yat-standard-input__label {
            transform: translateY(-10%) scale(0.75);

            @media (min-width: ${(props) => props.theme.breakpoints.tabletSmall}) {
                transform: translateY(10%) scale(0.75);
            }
        }
    }

    // TODO: Because of the previous reliance on 'v2-global-reset',
    // we are applying some nested element styled until we can
    // implement a better solution.
    input {
        margin: 0;
        padding: 0;
    }

    svg {
        fill: white;
    }
`;

export const Subheading = styled.div`
    font-weight: 500;
    font-size: 16px;
    line-height: 120%;
    text-align: center;
    letter-spacing: -0.03em;
    margin-top: 10px;
    opacity: 0.5;

    @media (min-width: ${({ theme }) => theme.breakpoints.mobile}) {
        margin-top: 20px;
    }
`;

export const BackButtonWrapper = styled.div`
    position: absolute;
    top: 20px;
    left: 25px;
    button {
        max-width: 48px;
        max-height: 48px;
    }
`;

export const SectionWrapper = styled.div`
    display: grid;
    align-content: baseline;
    justify-items: center;
    gap: 10px;
`;

export const ButtonWrapper = styled.div`
    && {
        button {
            width: 100% !important;
        }
    }
`;
